module.exports = __webpack_public_path__ + "static/media/missing_provider_photo.3a069740.svg";